// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-parent {
  display: none;
  justify-content: center;
  align-items: center;
  padding-bottom: 10%;
  background-color: var(--dark-color-dark-transparent-25);
  color: var(--font_inactive_color);
  z-index: var(--z-index-modal);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
  pointer-events: none;
}
.modal-parent.show {
  pointer-events: all;
  display: flex;
  opacity: 1;
}
.modal-parent .ev-modal-dialog {
  height: 100%;
  min-width: 520px;
  min-height: 240px;
  height: fit-content;
  max-width: calc(100vw - 48px);
  margin: 0;
}
.modal-parent .modal-dialog-centered {
  justify-content: center;
}
.modal-parent_title, .modal-parent .ev-modal-title {
  font-size: var(--text-size-large);
  height: var(--text-size-large);
}
.modal-parent .center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-parent .ev-modal-container {
  background-color: var(--white-color-lightest);
  min-height: 100px;
  width: 720px;
  height: fit-content;
  padding: 8px;
  position: relative;
  z-index: 20;
  box-shadow: var(--omni-shadow);
  font-size: var(--text-size-normal);
  overflow: hidden;
  padding: 16px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.modal-parent .ev-modal-container .row,
.modal-parent .ev-modal-container .col {
  margin: 0;
  padding: 0;
}
.modal-parent .ev-modal-container hr {
  width: 200vw;
  margin-block-start: 0%;
  transform: translateX(-50vw);
  color: var(--border-color);
}
.modal-parent .ev-modal-container .ev-modal-header {
  flex: 1 1;
  height: 36px;
  max-height: 36px;
  min-height: 36px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}
.modal-parent .ev-modal-container .ev-modal-body {
  flex: 1 1;
  width: 100%;
}
.modal-parent .ev-modal-container .ev-modal-footer {
  flex: 1 1;
  height: 36px;
  max-height: 36px;
  min-height: 36px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-parent .ev-modal-container .ev-modal-footer .button-row {
  flex: 1 1;
  width: 100%;
  height: 36px;
  max-height: 36px;
  min-height: 36px;
  display: flex;
  justify-content: flex-end;
}
.modal-parent .ev-modal-container .ev-modal-footer .button-row .button-element {
  height: 100%;
}
.modal-parent .ev-modal-container .ev-modal-footer .button-row .button-element:last-child {
  margin-left: 8px;
}
.modal-parent .ev-modal-container .ev-modal-footer .button-row .button-element .button {
  min-width: 120px;
}
.modal-parent.bginvisible {
  background: none;
}
.modal-parent.notbgevents {
  pointer-events: none;
}
.modal-parent #close {
  width: 25px;
  height: 25px;
  right: 0;
  top: 0;
  padding: 0;
  border: none;
  border-radius: 4px;
  color: var(--danger-color-dark);
  background-color: var(--white-color-lightest);
  cursor: pointer;
}
.modal-parent #close:hover {
  color: var(--danger-color-dark);
}
@media (max-width: 575px) {
  .modal-parent #close {
    left: 0;
  }
}
.modal-parent .modal-right {
  margin-left: 70vw;
  margin-top: 45px;
}
.modal-parent .modal-left {
  margin-left: 16vw;
  margin-top: 45px;
}
.modal-parent .modal-background {
  background-color: rgba(0, 0, 0, 0.4980392157);
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Modal.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uDAAA;EACA,iCAAA;EACA,6BAAA;EAEA,eAAA;EACG,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EAGH,oBAAA;AAFD;AAGC;EACC,mBAAA;EACA,aAAA;EACA,UAAA;AADF;AAIC;EACC,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AAFF;AAIC;EACC,uBAAA;AAFF;AAIC;EACC,iCAAA;EACA,8BAAA;AAFF;AAKC;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;AAHF;AAMC;EACC,6CAAA;EACA,iBAAA;EAGA,YAAA;EACA,mBAAA;EAEA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,8BAAA;EAOA,kCAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAdF;AAAE;;EAEC,SAAA;EACA,UAAA;AAEH;AAWE;EACC,YAAA;EACA,sBAAA;EACA,4BAAA;EACA,0BAAA;AATH;AAYE;EACC,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AAVH;AAYE;EACC,SAAA;EACA,WAAA;AAVH;AAcE;EACC,SAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAZH;AAcG;EACC,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;AAZJ;AAcI;EACC,YAAA;AAZL;AAaK;EACC,gBAAA;AAXN;AAcK;EACC,gBAAA;AAZN;AAmBC;EACC,gBAAA;AAjBF;AAmBC;EACC,oBAAA;AAjBF;AAoBC;EACC,WAAA;EACA,YAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,6CAAA;EACA,eAAA;AAlBF;AAmBE;EACC,+BAAA;AAjBH;AAmBE;EAdD;IAeE,OAAA;EAhBD;AACF;AAmBE;EACC,iBAAA;EACA,gBAAA;AAjBH;AAmBE;EACC,iBAAA;EACA,gBAAA;AAjBH;AAmBE;EACC,6CAAA;AAjBH","sourcesContent":[".modal-parent {\r\n\tdisplay: none;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tpadding-bottom: 10%;\r\n\tbackground-color: var(--dark-color-dark-transparent-25);\r\n\tcolor: var(--font_inactive_color);\r\n\tz-index: var(--z-index-modal);\r\n\r\n\tposition: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: none;\r\n    width: 100%;\r\n    height: 100%;\r\n    overflow-x: hidden;\r\n    overflow-y: auto;\r\n    outline: 0;\r\n\r\n\t//開いている時のみクリックイベントを受け付ける\r\n\tpointer-events: none;\r\n\t&.show{\r\n\t\tpointer-events: all;\r\n\t\tdisplay: flex;\r\n\t\topacity: 1;\r\n\t}\r\n\r\n\t.ev-modal-dialog {\r\n\t\theight: 100%;\r\n\t\tmin-width : 520px;\r\n\t\tmin-height: 240px;\r\n\t\theight: fit-content;\r\n\t\tmax-width: calc(100vw - 48px);\r\n\t\tmargin: 0;\r\n\t}\r\n\t.modal-dialog-centered {\r\n\t\tjustify-content: center;\r\n\t}\r\n\t&_title,.ev-modal-title {\r\n\t\tfont-size: var(--text-size-large);\r\n\t\theight: var(--text-size-large);\r\n\t}\r\n\r\n\t.center {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t}\r\n\r\n\t.ev-modal-container {\r\n\t\tbackground-color: var(--white-color-lightest);\r\n\t\tmin-height: 100px;\r\n\r\n\t\t//デフォルトサイズ\r\n\t\twidth: 720px;\r\n\t\theight: fit-content;\r\n\r\n\t\tpadding: 8px;\r\n\t\tposition: relative;\r\n\t\tz-index: 20;\r\n\t\tbox-shadow: var(--omni-shadow);\r\n\t\t.row,\r\n\t\t.col {\r\n\t\t\tmargin: 0;\r\n\t\t\tpadding: 0;\r\n\t\t}\r\n\r\n\t\tfont-size: var(--text-size-normal);\r\n\t\toverflow: hidden;\r\n\t\tpadding: 16px;\r\n\t\tborder-radius: 8px;\r\n\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tjustify-content: space-between;\r\n\t\talign-items: center;\r\n\r\n\t\thr{\r\n\t\t\twidth: 200vw;\r\n\t\t\tmargin-block-start:0%;\r\n\t\t\ttransform: translateX(-50vw);\r\n\t\t\tcolor: var(--border-color);\r\n\t\t}\r\n\r\n\t\t.ev-modal-header{\r\n\t\t\tflex:1;\r\n\t\t\theight: 36px;\r\n\t\t\tmax-height: 36px;\r\n\t\t\tmin-height: 36px;\r\n\t\t\twidth: 100%;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\t\t\tmargin-bottom: 16px;\r\n\t\t}\r\n\t\t.ev-modal-body{\r\n\t\t\tflex:1;\r\n\t\t\twidth: 100%;\r\n\t\t}\r\n\r\n\t\t\r\n\t\t.ev-modal-footer{\r\n\t\t\tflex:1;\r\n\t\t\theight: 36px;\r\n\t\t\tmax-height: 36px;\r\n\t\t\tmin-height: 36px;\r\n\t\t\twidth: 100%;\r\n\t\t\tdisplay: flex;\r\n\t\t\tjustify-content: space-between;\r\n\t\t\talign-items: center;\r\n\r\n\t\t\t.button-row {\r\n\t\t\t\tflex:1;\r\n\t\t\t\twidth: 100%;\r\n\t\t\t\theight: 36px;\r\n\t\t\t\tmax-height: 36px;\r\n\t\t\t\tmin-height: 36px;\r\n\t\t\t\tdisplay: flex;\r\n\t\t\t\tjustify-content: flex-end;\r\n\t\r\n\t\t\t\t.button-element{\r\n\t\t\t\t\theight: 100%;\r\n\t\t\t\t\t&:last-child{\r\n\t\t\t\t\t\tmargin-left: 8px;\r\n\t\t\t\t\t}\r\n\r\n\t\t\t\t\t.button{\r\n\t\t\t\t\t\tmin-width: 120px;\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t}\r\n\t&.bginvisible {\r\n\t\tbackground: none;\r\n\t}\r\n\t&.notbgevents {\r\n\t\tpointer-events: none;\r\n\t}\r\n\r\n\t#close {\r\n\t\twidth: 25px;\r\n\t\theight: 25px;\r\n\t\tright: 0;\r\n\t\ttop:0;\r\n\t\tpadding: 0;\r\n\t\tborder: none;\r\n\t\tborder-radius: 4px;\r\n\t\tcolor: var(--danger-color-dark);\r\n\t\tbackground-color: var(--white-color-lightest);\r\n\t\tcursor: pointer;\r\n\t\t&:hover {\r\n\t\t\tcolor: var(--danger-color-dark);\r\n\t\t}\r\n\t\t@media (max-width: 575px)\t{\r\n\t\t\tleft: 0;\r\n\t\t}\r\n\t}\r\n\t.modal{\r\n\t\t&-right {\r\n\t\t\tmargin-left: 70vw;\r\n\t\t\tmargin-top: 45px;\r\n\t\t}\r\n\t\t&-left {\r\n\t\t\tmargin-left: 16vw;\r\n\t\t\tmargin-top: 45px;\r\n\t\t}\r\n\t\t&-background {\r\n\t\t\tbackground-color: #0000007f;\r\n\t\t}\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
